import React, { useEffect, useState, useRef } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  FormFeedback,
  Modal,
  Button,
} from "reactstrap"

import Select from "react-select"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import { Link, useHistory, useParams, useLocation } from "react-router-dom"

// import images
import logo from "assets/images/logo-large.png"

import "../../../assets/scss/custom/style.css"

import Autocomplete from "@material-ui/lab/Autocomplete"
import Box from "@material-ui/core/Box"
import { TextField } from "@material-ui/core"
import Snackbars from "../../../Utils/Snackbars"
import useRequestsWOAccessToken from "../../../Utils/useRequestsWOAccessToken"
import i18next from "i18next"

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? "#036B41"
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? "#fff"
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Address = props => {
  //meta title
  document.title = i18next.t("Register PG document title")
  const history = useHistory()
  const { getRequestWOAccessToken, postRequestWOAccessToken } =
    useRequestsWOAccessToken()
  const { referral_code } = useParams()
  const location = useLocation()
  const inputRef = useRef(null)

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const [formData1, setFormData1] = React.useState({
    country: { label: "Spain", value: "Spain" },
    country_code: { id: 212, title: "ES +34", code: "ES", value: 34 },
  })
  const [CustomError1, setCustomError1] = React.useState({
    country: "",
    country_code: "",
  })
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      address: "",
      building: "",
      floor: "",
      zipAddress: "",
      street: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
    },
    validationSchema: Yup.object({
      address: Yup.string().required(
        i18next.t("Register PG Address is required"),
      ),
      building: Yup.string().required(i18next.t("Building is required")),
      floor: Yup.string(),
      zipAddress: Yup.string()
      .required(i18next.t("Zip Address is required"))
      .test(
        "spain-zip-validation",
        i18next.t("Zip code must be exactly 5 numeric digits"),
        function (value) {
          if (StateCountry === "Spain") {
            return /^\d{5}$/.test(value || "");
          }
          return true; // Skip validation if not Spain
        }
      )
    }),
    onSubmit: async values => {
      try {
        let submit1 = document.getElementById("submit1")
        submit1.disabled = true
        submit1.textContent = i18next.t("Processing...")
        const jsonpar = JSON.stringify({
          u_id: UID,
          address: values.address,
          building: values.building,
          floor: values.floor,
          zip: values.zipAddress,
          street: values.street,
          city: values.city,
          state: values.state,
          postal_code: values.postal_code,
          country: values.country,
        })
        const res = await postRequestWOAccessToken("signup-address", jsonpar)
        if (res && res.code === 200) {
          let originalText = res.data
          history.push("/tax", {
            id: UID,
            email: Email,
            country_code: CountryCode,
            phone: Phone,
            country: StateCountry,
            status: "success",
            message: res.message,
          })
        } else {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }))
        }
        resetAlertData()

        submit1.disabled = false
        submit1.textContent = i18next.t("Continue")
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([])
  const [AllCountriesCustomData2, setAllCountriesCustomData2] = React.useState(
    [],
  )
  const handleLoadGetAllCountries = async () => {
    const res = await getRequestWOAccessToken("get-all-countries")
    if (res && res.code === 200) {
      let originalText = res.data

      let tempArr = []
      originalText.forEach(element => {
        let temp = {
          label: element.country_name,
          value: element.country_name,
        }
        tempArr.push(temp)
      })
      tempArr = [
        {
          options: tempArr,
        },
      ]
      setAllCountriesCustomData2(tempArr)

      tempArr = []
      originalText.forEach(element => {
        let temp = {
          id: element.id,
          title: element.country_code + " +" + element.phone_code,
          code: element.country_code,
          value: element.phone_code,
        }
        tempArr.push(temp)
      })
      setAllCountriesCustomData(tempArr)
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }
  const [PreferredLanguage, setPreferredLanguage] = React.useState("eng")
  const onChangePreferredLanguage = e => {
    i18next.changeLanguage(e.target.value)
    setPreferredLanguage(e.target.value)
    localStorage.setItem("I18N_LANGUAGE", e.target.value)
  }

  const handleLoadGetSignupStatus = async u_id => {
    const jsonpar = JSON.stringify({
      u_id: u_id,
    })

    const res = await postRequestWOAccessToken("signup-status", jsonpar)
    if (res && res.code === 200) {
      let originalText = res.data
      if (originalText.is_email_verified == 0) {
        history.push("/email-verification", {
          id: u_id,
          email: originalText.email,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.phone == "" ||
        originalText.phone == null ||
        originalText.phone == undefined
      ) {
        history.push("/add-phone", {
          id: u_id,
          email: originalText.email,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.is_phone_verified == 0) {
        history.push("/phone-verification", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.first_name == null ||
        originalText.first_name == "" ||
        originalText.last_name == null ||
        originalText.last_name == ""
      ) {
        history.push("/personal-details", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.address == null || originalText.address == "") {
        return
      } else if (originalText.tax_id == null || originalText.tax_id == "") {
        history.push("/tax", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          country: originalText.country,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.accept_terms == "false") {
        history.push("/terms", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else {
        history.push("/login")
      }
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
  }

  const [UID, setUID] = React.useState(0)
  const [Email, setEmail] = React.useState("")
  const [CountryCode, SetCountryCode] = React.useState("")
  const [StateCountry, SetStateCountry] = React.useState("")
  const [Phone, setPhone] = React.useState("")
  React.useEffect(() => {
    const language = localStorage.getItem("I18N_LANGUAGE")
    if (!language) setPreferredLanguage("sp")
    else setPreferredLanguage(language)

    handleLoadGetAllCountries()

    if (referral_code) {
      validation1.setValues({
        ...validation1.values,
        referral_code: referral_code,
      })
    }
    if (
      typeof location.state !== "undefined"
    ) {
      handleLoadGetSignupStatus(location.state.id)
      setUID(location.state.id)
      setEmail(location.state.email)
      SetCountryCode(location.state.country_code)
      SetStateCountry(location.state.country)
      setPhone(location.state.phone)
      if(location.state.message){
        setAlertData(AlertData => ({
          ...AlertData,
          variant: location.state.status,
          message: location.state.message,
        }))
        resetAlertData()
      }
    }

    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const script = document.createElement("script")
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&libraries=places` // <-- your API key here
        script.async = true
        document.body.appendChild(script)
        script.addEventListener("load", initAutocomplete)
      } else {
        initAutocomplete()
      }
    }

    const initAutocomplete = () => {
      if (inputRef.current) {
        const autocomplete = new window.google.maps.places.Autocomplete(
          inputRef.current,
          { types: ["geocode"] },
        )

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace()

          if (!place.address_components) return

          // Extract details from address_components
          let street = "" // Street name
          let city = ""
          let state = "" // Administrative area level 1 (e.g., California)
          let postal_code = ""
          let country = ""
          for (const component of place.address_components) {
            if (component.types.includes("country")) {
              country = component.long_name
            } else if (component.types.includes("postal_code")) {
              postal_code = component.long_name
            } else if (component.types.includes("locality")) {
              city = component.long_name
            } else if (
              component.types.includes("administrative_area_level_1")
            ) {
              state = component.long_name
            } else if (component.types.includes("sublocality")) {
              street = component.long_name
            } else if (component.types.includes("route")) {
              street = component.long_name
            }
          }

          validation1.setFieldValue("address", place.formatted_address || "")
          validation1.setFieldValue("street", street)
          validation1.setFieldValue("street", street)
          validation1.setFieldValue("city", city)
          validation1.setFieldValue("state", state)
          validation1.setFieldValue("postal_code", postal_code)
          validation1.setFieldValue("country", country)
        })
      }
    }

    loadGoogleMapsScript()
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="p-0 container-fluid">
        {/* <select
          className="form-select top-right-lang"
          name="preferred_language"
          value={PreferredLanguage}
          onChange={e => onChangePreferredLanguage(e)}
        >
          <option value={"eng"}>English</option>
          <option value={"sp"}>Spanish</option>
        </select> */}
        <Row className="g-0">
          <Col className="LeftImg">
            <div className="auth-full-page-content p-3 bg-white">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="auth-logo-light">
                      <div className="mb-1">
                        <span className="">
                          {" "}
                          <img src={logo} alt="" height="60" />{" "}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="my-auto">
                    <div className="text-primary p-4">
                      <h2 className="text-black mb-3">
                        {i18next.t("Enter your residential address")}
                      </h2>
                      <p className="text-black" style={{ fontSize: '17px' }}>
                        {i18next.t("For regulatory reasons we need to know your place of residence")}
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="p-2">
                        <div className="form-horizontal">
                          <div className="row">
                            <Col md={12}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {i18next.t("Enter Address")} :
                                </Label>
                                <input
                                  type="text"
                                  ref={inputRef}
                                  name="address"
                                  placeholder={i18next.t("Enter Address")}
                                  className={`form-control ${validation1.touched.address && validation1.errors.address ? "is-invalid" : ""}`}
                                  onChange={validation1.handleChange}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.address}
                                />
                                {validation1.touched.address &&
                                  validation1.errors.address && (
                                    <FormFeedback type="invalid">
                                      {validation1.errors.address}
                                    </FormFeedback>
                                  )}
                              </div>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {i18next.t("Building")}
                                </Label>
                                <input
                                  type="text"
                                  name="building"
                                  placeholder={i18next.t("Building")}
                                  className={`form-control ${validation1.touched.building && validation1.errors.building ? "is-invalid" : ""}`}
                                  onChange={validation1.handleChange}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.building}
                                />
                                {validation1.touched.building && validation1.errors.building && (
                                  <FormFeedback type="invalid">
                                    {validation1.errors.building}
                                  </FormFeedback>
                                )}
                              </div>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {i18next.t("Floor1")}
                                </Label>
                                <input
                                  type="text"
                                  name="floor"
                                  placeholder={i18next.t("Floor1")}
                                  className={`form-control ${validation1.touched.floor && validation1.errors.floor ? "is-invalid" : ""}`}
                                  onChange={validation1.handleChange}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.floor}
                                />
                                {validation1.touched.floor && validation1.errors.floor && (
                                  <FormFeedback type="invalid">
                                    {validation1.errors.floor}
                                  </FormFeedback>
                                )}
                              </div>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {i18next.t("Zip Address")}
                                </Label>
                                <input
                                  type="text"
                                  name="zipAddress"
                                  placeholder={i18next.t("Zip Address")}
                                  className={`form-control ${validation1.touched.zipAddress && validation1.errors.zipAddress ? "is-invalid" : ""}`}
                                  onChange={validation1.handleChange}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.zipAddress}
                                />
                                {validation1.touched.zipAddress && validation1.errors.zipAddress && (
                                  <FormFeedback type="invalid">
                                    {validation1.errors.zipAddress}
                                  </FormFeedback>
                                )}
                              </div>
                            </Col>
                          </div>

                          <div className="mt-4 d-grid">
                            <Button
                              id="submit1"
                              onClick={e => {
                                e.preventDefault()
                                validation1.handleSubmit()
                                return false
                              }}
                              data-toggle="modal"
                              data-target="#myModal"
                              className="btn btn-primary btn-block"
                            >
                              {" "}
                              {i18next.t("Continue")}{" "}
                            </Button>
                          </div>
                        </div>
                        <div className="mt-3 text-center">
                          <p className="mb-0"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="footer-text-color">
                      {" "}
                      © {new Date().getFullYear()} Tokenized Green.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="rightImg">
            <div className="bgLogin"></div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default Address
